export default __webpack_public_path__ + "static/media/wallet-icon.9691c5d8.svg";